import {NOTIFICATION_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function getChatPageGenericInfo(
    path,
    userId,
    pageNumber = 0,
    pageRows = 10,
    sortField = 'id',
    sortOrder = -1,
    filterRequest = {},
) {
    return axiosInstance
        .post(`${NOTIFICATION_ENDPOINT}/${path}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
export function getChatListGenericInfo(
    path,
    userId,
    filterRequest = {},
    rows,
    dto = false,
    sortField = 'id',
    sortOrder = -1,
) {
    return axiosInstance
        .post(`${NOTIFICATION_ENDPOINT}/${path}/getList`, filterRequest, {
            params: {userId, rows, dto, sortField, sortOrder},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function createOrUpdateChatGenericInfo(path, userId, data = {}) {
    return axiosInstance
        .post(`${NOTIFICATION_ENDPOINT}/${path}/createOrUpdate`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function readChatMessage(participantId) {
    return axiosInstance
        .post(
            `${NOTIFICATION_ENDPOINT}/message/readChatMessage`,
            {},
            {
                params: {participantId},
            },
        )
        .then(res => res.data)
        .catch(error => console.log(error))
}
